/* global postID */
// postID is defined in live/wp-content/themes/ifcfilms/src/header-single.php

// bower lib requires
import $ from 'jquery';
import NProgress from 'nprogress';
import 'foundation-sites/js/foundation';
import videojs from 'video.js';

// global requires
import config from './../modules/globals/config';
import universal from './../modules/globals/universal';
import velocityAnims from './../modules/globals/velocity-animations';

// module requires
import headerScroll from './../modules/header-scroll';
import search from './../modules/search';
import trailerDrawerRotation from './../modules/trailer-drawer-rotation';
import trailerDrawerClose from './../modules/trailer-drawer-close';
import trailerDrawerOpen from './../modules/trailer-drawer-open';
import hideAndLoadVideo from './../modules/hide-load-video';
import videoEvents from './../modules/video-events';
import videoPlayerStart from './../modules/video-player-start';
import singleAccordion from './../modules/single-accordion';
import photoGallery from './../modules/single-gallery';
import socialFB from './../modules/social-facebook';
import socialXTW from './../modules/social-x-tw';
import './../modules/quote-rotator';

/*
local vars
 */
let $document = $(document),
  body = $('body'),
  mainTitle = $('.title h1'),
  trailerDrawer = $('.trailer-drawer'),
  trailerDrawerDesktop = trailerDrawer.find('.desktop-drawer'),
  trailerDrawerBG = trailerDrawer.find('.drawer-bg'),
  trailerDrawerTitle = $('.drawer-info h2'),
  trailerDrawerInfoTitle = $('#drawerInfoTitle'),
  trailerDrawerInfoSeeMore = $('#seeMoreLink'),
  trailerDrawerInfoText = $('#releaseTextInfo'),
  leftTrailer = $('#leftTrailer'),
  rightTrailer = $('#rightTrailer'),
  singlePage = $('.single-page'),
  innerWrap = $('.inner-wrap'),
  leftOffCanvasMenu = $('.left-off-canvas-menu'),
  leftOffCanvasToggle = $('.left-off-canvas-toggle'),
  handle = $('.handle'),
  enterOnCanvas = $('.enter-on-canvas'),
  exitOffCanvas = $('.exit-off-canvas'),
  desktopDrawer = $('.desktop-drawer'),
  playerLightbox = $('#playerLightbox'),
  loadingSpinner = $('.vjs-loading-spinner'),
  headerContainer = $('.header-container'),
  trailerPoster = $('.trailer-poster'),
  inputRange = $('input[type="range"]');

/*
startup
 */
// start foundation responsive
$document.foundation();

NProgress.configure({ showSpinner: false });

let universalInit = new universal();
let isMobile = universalInit.isMobileDevice();

config.isMobile = isMobile;
config.isiPad = universalInit.isiPad();
config.isAndroid = universalInit.isAndroid();
config.isNoHover = universalInit.isNoHover();

// start top nprogress bar in desktop
NProgress.start();

config.currentPage = 'single';

// set up velocity ui registrations
new velocityAnims();

if (isMobile && config.theWindow.width() <= 640) {
  // set font-size and margin of title
  let chars = mainTitle.text().length;

  if (chars >= 26) {
    mainTitle.parent().addClass('smaller-text');
  } else if (chars >= 15) {
    // only set smaller during scrolling
    mainTitle.parent().addClass('scroll-smaller-text');
  }

  // mobile + desktop handle click
  handle.on('click', function (e) {
    e.preventDefault();

    // make sure trailer modal is closed
    $('#trailerModal .close-modal').trigger('click');

    if (!$(this).hasClass('close')) {
      // set single-page height and overflow to stop sideways scrolling
      singlePage.css({ 'top': '0', 'height': config.theWindow.height(), 'overflow-y': 'hidden' });

      $(this).addClass('close');

    } else {
      constrainSinglePage();
    }
  });
}

// set up trailer drawer interval rotation
if (config.theWindow.width() > 640) {
  $.merge(leftOffCanvasToggle, enterOnCanvas).on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    // prevent default foundation functionality before trawer loads
  });

  config.trailerDrawerInitialized = initTrailerDrawer();

} else if ($('.no-touch').length > 0) {
  // when starting out at mobile size and resizing
  // the trailer object can block any elements behind from being clicked
  // like nav and trailer  button
  $(window).on('resize', function () {
    if (config.theWindow.width() > 640 && config.trailerDrawerInitialized === undefined) {
      config.trailerDrawerInitialized = initTrailerDrawer();
    }
  });
}

function initTrailerDrawer () {
  // is fullscreen available? not in IE9 and 10
  if (!document.fullscreenEnabled &&
    !document.webkitFullscreenEnabled &&
    !document.mozFullScreenEnabled &&
    !document.msFullscreenEnabled
  ) {
    $('.fullscreen').remove();
  }

  jQuery.support.cors = true;

  $.get(window.location.origin + '/?__api=1&films=featured', function (response) {
    config.featuredTrailersJSON = [];

    // if film page remove current film from rotation
    if ($('body').hasClass('single-film') && postID !== undefined) {
      for (let film of Object.keys(response.data)) {
        if (response.data[film].hasOwnProperty('ID') && response.data[film]['ID'] !== postID) {
          config.featuredTrailersJSON.push(response.data[film]);
        }
      }
    } else {
      config.featuredTrailersJSON = response.data;
    }

    config.max = config.featuredTrailersJSON.length - 1;

    // initial call to drawer rotation to get started
    config.trailerDrawerIsRotating = true;
    trailerDrawerRotation(
      trailerDrawerBG,
      trailerDrawerTitle,
      trailerDrawerInfoTitle,
      trailerDrawerDesktop,
      leftTrailer,
      rightTrailer,
      trailerDrawerInfoSeeMore,
      trailerDrawerInfoText
    );

    $('#playerLightbox input[type="range"]').rangeslider({ polyfill: false });
    $('#trailerModal input[type="range"]').rangeslider({ polyfill: false });

    // set up for animation
    playerLightbox.velocity('player-lightbox-hide', {
      complete: function () {
        $(this).css('opacity', 1);

        // lightbox is hidden/initialized, now we can properly open it
        $.merge(leftOffCanvasToggle, enterOnCanvas).on('click', function () {
          if (config.trailerDrawerIsAnimating) {
            return;
          }

          config.trailerDrawerIsAnimating = true;

          // replicate default foundation functionality
          // that we prevented in stopProp
          $('.off-canvas-wrap').addClass('move-right');

          body.toggleClass('drawer-open');

          if (body.hasClass('drawer-open')) {
            handle.addClass('close');
            trailerDrawerOpen(
              handle,
              headerContainer,
              trailerDrawerBG,
              innerWrap,
              desktopDrawer,
              playerLightbox,
              leftOffCanvasMenu,
              $('#playerLightbox .vjs-loading-spinner')
            );
          } else {
            trailerDrawerClose(
              handle,
              playerLightbox,
              innerWrap,
              headerContainer,
              leftOffCanvasMenu,
              trailerDrawerBG,
              trailerDrawerTitle,
              trailerDrawerInfoTitle,
              trailerDrawerDesktop,
              leftTrailer,
              rightTrailer
            );
          }
        });
      },
    });
  });

  // drawer initialization complete
  return true;
}


/*
Inits
 */
// Search
search.init();

// Photo Gallery
photoGallery($('.single-photo-gallery'));
// resize photo gallery
if ($('.single-photo-gallery-poster').length) {
  $(window).on('resize', resizePhotoGallery);

  resizePhotoGallery();

  setTimeout(function () {
    // wait for photo gallery to resize
    singleAccordion();
  }, 250);

} else {
  // Accordion
  singleAccordion();
}

// Social Buttons
socialFB($('.fb-share'));
socialXTW($('.x-tw-share'));

/*
Click events
 */
$('.toggle-topbar.mobile-menu-icon').on('click', function (e) {
  e.preventDefault();

  $(this).toggleClass('active');

  // toggle pause of flexslider if mobile menu expanded
  if ($('.top-bar').hasClass('expanded')) {
    handle.show();
  } else {
    handle.hide();
  }
});

// exit off canvas link click
exitOffCanvas.on('click', function () {
  if (config.trailerDrawerIsAnimating) {
    return;
  }

  config.trailerDrawerIsAnimating = true;

  if (isMobile && config.theWindow.width() <= 640) {
    constrainSinglePage();
  } else {
    body.removeClass('drawer-open');

    trailerDrawerClose(
      handle,
      playerLightbox,
      innerWrap,
      headerContainer,
      leftOffCanvasMenu,
      trailerDrawerBG,
      trailerDrawerTitle,
      trailerDrawerInfoTitle,
      trailerDrawerDesktop,
      leftTrailer,
      rightTrailer
    );
  }
});

function constrainSinglePage () {
  handle.removeClass('close');

  if (isMobile) {
    // wait for close trailer css transition to end to reset single page height and overflow
    innerWrap.one('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function () {
      singlePage.css({ 'overflow-y': 'auto', 'height': '100%' });

      // apparently stil keeps listening so turn it off
      innerWrap.off('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd');
    });
  }
}

// left and right trailer click inside desktop trailer drawer
$.merge(leftTrailer, rightTrailer).on('click', function (e) {
  e.preventDefault();
  NProgress.start();

  // pause current video
  $('.pause').trigger('click');

  let videoId = $(this).data('video-id');
  let pos = $(this).data('position');

  // set the current trailer number to clicked trailer
  config.currentTrailerNum = pos;

  // hide trailer drawer player lightbox, then load new video and info, then reveal again
  hideAndLoadVideo(
    playerLightbox,
    videoId,
    pos,
    trailerDrawerBG,
    trailerDrawerTitle,
    trailerDrawerInfoTitle,
    trailerDrawerDesktop,
    $('#playerLightbox .vjs-loading-spinner'),
    leftTrailer,
    rightTrailer,
    trailerDrawerInfoSeeMore,
    trailerDrawerInfoText
  );
});

// mobile trailer poster click
trailerPoster.on('click', function (e) {
  e.preventDefault();

  let videoId = $(this).data('video-id');
  let title = $(this).data('title');

  // open foundation modal with video player
  $('#videoModal').foundation('reveal', 'open', {
    data: { videoId: videoId, title: title },
  });
});

let vidIds = [];

// video gallery

function loadNextPoster (player) {
  let id = vidIds.shift();

  player.catalog.getVideo(id, function (error, video) {
    $('.single-video-gallery div[data-video-id="' + id + '"]').css({
      'background-image': 'url(' + video.poster + ')',
    });

    if (vidIds.length) {
      loadNextPoster(player);
    } else {
      player.dispose();
    }
  });
}

$('.single-video-gallery .video-js').each(function () {
  vidIds.push($(this).attr('data-video-id'));
});

if (vidIds.length) {
  videojs('galleryPosterLoader').ready(function () {
    loadNextPoster(this);
  });
}

// trailer button click
$('.single-trailer, .single-video-gallery .video-js').on('click', function (e) {
  e.preventDefault();

  let videoId = $(this).data('video-id');
  let title = $(this).data('title');

  let modal = $('.reveal-modal-bg');

  if (typeof modal !== 'undefined') {
    modal.css({ 'display': 'block', 'opacity': '1' });
  }

  // open foundation modal with video player
  $('#trailerModal').foundation('reveal', 'open', {
    data: { videoId: videoId, title: title },
  });
});


let filterToggle = $('.filterToggle');

filterToggle.on('click', function () {
  $(this).next('ul').slideToggle(config.fastTiming);
  $(this).toggleClass('active');
  event.preventDefault();
});

if (filterToggle.hasClass('expanded')) {
  $('.filterToggle.expanded').next('ul').slideToggle(config.fastTiming);
}

$('.single-photo-gallery-more').on('click', function (e) {
  e.preventDefault();

  let remainingImages = $('.single-photo-gallery li.hide');
  let i = 0;

  remainingImages.each(function () {
    if (i < 5) {
      $(this).fadeIn(400).removeClass('hide');
    }

    i++;
  });

  if (remainingImages.length < 6) {
    hideShowMore($('.single-photo-gallery-more'));
  }

  // if in accordion, reset the height
  let content = $(this).closest('.content.active');
  content.css('height', 'auto');

  let height = content.height();
  content.attr('data-height', height).css({
    'opacity': 1,
    'height' : height,
    'display': 'block',
  });

  resizePhotoGallery();

  $(document).foundation('equalizer', 'reflow');
});

function resizePhotoGallery () {
  clearTimeout(window.resizePhotoGalleryTimeout);

  window.resizePhotoGalleryTimeout = setTimeout(function () {
    let poster = $('.single-photo-gallery-poster');
    let moreButton = $('.single-photo-gallery-more:visible');
    let photoHeight;

    if (config.theWindow.width() > 640) {
      if (moreButton.length) { // if show more is visble
        let buttonHeight = (moreButton.length) ? moreButton.outerHeight(true) : 0;
        photoHeight = (poster.height() - parseInt(poster.css('padding-bottom')) * 2 - buttonHeight) / 2;
      } else {
        photoHeight = (poster.height() - parseInt(poster.css('padding-bottom'))) / 2;
      }

    } else {
      photoHeight = (poster.height() - parseInt(poster.css('padding-bottom'))) / 2;
    }

    $('.single-photo-gallery li a').css('max-height', photoHeight);
    $(document).foundation('equalizer', 'reflow');
  }, 200);
}

$('.single-video-gallery-more').on('click', function (e) {
  e.preventDefault();

  let remainingVideos = $('.single-video-gallery div.hide');
  let i = 0;

  remainingVideos.each(function () {
    if (i < 2) {
      $(this).fadeIn(400).removeClass('hide');
    }

    i++;
  });

  if (remainingVideos.length < 3) {
    hideShowMore($('.single-video-gallery-more'));
  }

  $(document).foundation('equalizer', 'reflow');
});

function hideShowMore (btn) {
  btn.fadeOut().hide();
}


function closeModal (e) {
  e.preventDefault();

  $(window).off('scroll', closeModal);

  $('#trailerModal .vjs-social-cancel').click();

  if (config.myPlayer !== null) {
    let myPlayerEvents = new videoEvents(config.myPlayer);
    myPlayerEvents.stopVideoPlayer();
  }

  setTimeout(function () {
    // reset myPlayer
    config.myPlayer = null;

    // recreate foundation close modal so that display doesn't get set to none and cause player issues
    $('#trailerModal, #videoModal').velocity({ opacity: 0 }, {
      duration: config.animationTiming,
      easing  : config.easing,
      complete: function () {
        $(this).css({ visibility: 'hidden' }).removeClass('open');
      },
    });

    $('.reveal-modal-bg').velocity({ opacity: 0 }, {
      duration: config.animationTiming,
      easing  : config.easing,
      display : 'none',
    });
  }, 0);
}

$document.on('click', '.close-modal', closeModal);

/*
listen events
 */

// modal open listen
$document.on('opened.fndtn.reveal', '[data-reveal]', function () {
  let modal = $(this);

  // grab video id and title from passed in data params
  if (typeof modal.data('revealInit').data !== 'undefined') {
    let videoId = modal.data('revealInit').data.videoId;
    let videoTitle = modal.data('revealInit').data.title;

    $('#videoModalTitle').text(videoTitle);

    if (modal.context.id === 'videoModal') {
      videoPlayerStart(loadingSpinner, videoId, 'main');
    } else if (modal.context.id === 'trailerModal') {
      videoPlayerStart($('#trailerModal .vjs-loading-spinner'), videoId, 'trailer');
    }
  }
});


// rangeslider input listen
$document.on('input', inputRange, function (e) {
  if (e.target.type !== 'range') {
    return;
  }

  let value = e.target.value;
  let myPlayerEvents = new videoEvents(config.myPlayer);

  myPlayerEvents.seek(value);
});

/*
scroll events
 */
config.theWindow.scroll(headerScroll);

headerScroll();

if (isMobile || config.theWindow.width() <= 640) {
  NProgress.done();
}
